import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy } from "firebase/firestore";
import { MdList } from "react-icons/md";
import { SiSpinrilla } from "react-icons/si"
import ReactStars from "react-rating-stars-component";
import moment from "moment"

import {AuthContext} from '../services/Session/Context'
import {FirebaseContext} from '../services/Firebase/Context'

const VehiculeFeedbackCard = ({ id, fullOpacity }) => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext)
  const [fb, setFb] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if(!id || !user) return
    let q = null
    let unsubscribe = null
    setLoading(true)
    q = query(collection(db, "feedbacks"), where("recordId", "==", id), where("organisationId", "==", user.organisationId), orderBy("date", 'desc'));
    setTimeout(() => {
      unsubscribe = onSnapshot(q, (querySnapshot) => {
        const fb = [];
        querySnapshot.forEach((doc) => {
          fb.push({id: doc.id, ...doc.data()});
        });
        setFb(fb)
        setLoading(false)
      });
    }, 0)
   
    return () => {
      if (unsubscribe) unsubscribe()
    }
  }, [db, id, user])

  return (
    <div className="shadow-md mt-5 ">
      <div className={`p-4 bg-gray-100 border-t-2 border-blue-400 rounded-t-lg ${fullOpacity ? 'bg-opacity-100' : 'bg-opacity-5'}`}>
        <div className="max-w-sm mx-auto md:w-full md:mx-0">
          <div className="inline-flex items-center space-x-4">
            <MdList className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
              <h1 className="text-gray-600">
                Retours client
              </h1>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className="py-5">
          <div className="pl-5 text-center">
            { fb.map((_fb, i) =>
              <div key={_fb.id}>
                {
                  _fb.recomandation
                  ? <small className="px-4 py-2 text-xs rounded-lg text-green-600 bg-green-200">
                      Ce client vous recommande
                    </small>
                  : <small className="px-4 py-2 text-xs rounded-lg text-red-600 bg-red-200">
                      Ce client ne vous recommande pas
                    </small>
                }
                
                <div className='flex flex-row mt-5'>
                  <p className="font-bold flex-1 text-right pr-2">
                    Note globale :
                  </p>
                  <div className='flex-1'>
                    <ReactStars
                      count={5}
                      edit={false}
                      size={20}
                      value={_fb.global}
                      activeColor={(
                        _fb.global >= 4
                        ? "#10B981"
                        : (
                          _fb.global <=2
                          ? "#EF4444"
                          : "#FBBF24"
                        )
                      )}
                    />
                  </div>
                </div>
                <div className='flex flex-row'>
                  <p className="flex-1 text-right pr-2">
                    Qualité de service :
                  </p>
                  <div className='flex-1'>
                    <ReactStars
                      count={5}
                      edit={false}
                      size={20}
                      value={_fb.quality}
                      activeColor={(
                        _fb.quality >= 4
                        ? "#10B981"
                        : (
                          _fb.quality <=2
                          ? "#EF4444"
                          : "#FBBF24"
                        )
                      )}
                    />
                  </div>
                </div>
                <div className='flex flex-row'>
                  <p className="flex-1 text-right pr-2">
                    Rapidité de service :
                  </p>
                  <div className='flex-1'>
                    <ReactStars
                      count={5}
                      edit={false}
                      size={20}
                      value={_fb.quickness}
                      activeColor={(
                        _fb.quickness >= 4
                        ? "#10B981"
                        : (
                          _fb.quickness <=2
                          ? "#EF4444"
                          : "#FBBF24"
                        )
                      )}
                    />
                  </div>
                </div>
                <div className='flex flex-row'>
                  <p className="flex-1 text-right pr-2">
                    Attractivité du prix :
                  </p>
                  <div className='flex-1'>
                    <ReactStars
                      count={5}
                      edit={false}
                      size={20}
                      value={_fb.price}
                      activeColor={(
                        _fb.price >= 4
                        ? "#10B981"
                        : (
                          _fb.price <=2
                          ? "#EF4444"
                          : "#FBBF24"
                        )
                      )}
                    />
                  </div>
                </div>
                <div className="flex-1 text-center">
                  Commentaires :
                  <blockquote className='text-sm'>{_fb.comments || 'Aucun'}</blockquote>
                </div>
                <small>
                  Avis laissé le {_fb.date && moment(_fb.date.toDate()).calendar()}
                </small>
                {(fb.length > 1 && i !== (fb.length - 1)) && <hr className='mb-5 mt-2'/>}
              </div>
            )}
            {
             loading && <SiSpinrilla size={18} className="mr-2 animate-spin" color='black' />
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default VehiculeFeedbackCard
